export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13971.16b20430.jpg";